/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:83caa596-990b-4487-a951-eccff6e83baa",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_bDYJKmUXp",
    "aws_user_pools_web_client_id": "3dbem392b4todrbkl0v5atglss",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "wirehydraapi",
            "endpoint": "https://liksef6prl.execute-api.us-east-2.amazonaws.com/dev",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "wirehydra-resources-public333d1-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
